"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Chip = _interopRequireDefault(require("../Chip"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _lodash = require("lodash");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["name", "value", "onChipClick", "append", "chip", "style"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Chips = function Chips(_ref) {
  var name = _ref.name,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? [] : _ref$value,
    onChipClick = _ref.onChipClick,
    Append = _ref.append,
    _ref$chip = _ref.chip,
    ChipComponent = _ref$chip === void 0 ? _Chip["default"] : _ref$chip,
    style = _ref.style,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleChipClick = function handleChipClick(chip) {
    return function (e) {
      onChipClick(e, chip);
    };
  };
  var setDataCy = function setDataCy(name, chipName) {
    if (name) {
      return {
        'data-cy': "".concat((0, _lodash.camelCase)(name), "-").concat((0, _lodash.camelCase)(chipName), "-chip")
      };
    } else {
      return {};
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
    direction: 'row',
    spacing: 1,
    pt: 0.5,
    pb: 0.5,
    flexWrap: 'wrap',
    children: value.map(function (chip, i) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Stack["default"], {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ChipComponent, _objectSpread(_objectSpread(_objectSpread({
          label: chip.name,
          id: chip.id,
          style: style,
          onClick: onChipClick && handleChipClick(chip)
        }, chip), props), setDataCy(name, chip.name)), chip.id)
      }, i);
    })
  });
};
var _default = exports["default"] = Chips;